import sdk from '@trazi/travelling-sdk/node';

export default ({ app }, inject) => {
  inject('travellingSDK', sdk(`${window.location.origin}/account`));
};
